import {createApp} from 'vue'
import App from './App.vue'
import Maska from 'maska'
import YSmartCaptcha from 'vue3-yandex-smartcaptcha'

createApp(App).use(Maska).use(YSmartCaptcha,  {
    siteKey: "ysc1_vBpl4TKRbhFWcShodAPGmkgfltRLcqKw7C92BV7G509400ab",
    lang: "Язык ('ru' | 'en' | 'be' | 'kk' | 'tt' | 'uk' | 'uz' | 'tr')"
}).mount('#app')
